import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import { usePlace } from 'commons/usePlace'

import { CANCEL } from 'app/constants/button'
import { SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const Delete = (props) => {
  const {
    closeMenu = () => {},
    onAction,
    title = '',
    description = '',
    rootAdmin = {},
    selected = [],
    selectedCount = null,
  } = props

  const place = usePlace()
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)
  const [isDisable, setIsDisable] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  useEffect(() => {
    const checkDisable =
      selected.length === 1 && selected.includes(place.creatorId)
    setIsDisable(checkDisable)
  }, [place.creatorId, selected])

  return (
    <div>
      {!isNil(rootAdmin) && selectedCount > 0 && (
        <Typography
          className={clsx(
            'text-14 font-500 whitespace-nowrap',
            isDisable ? 'text-grey-200' : 'text-red-500 cursor-pointer',
          )}
          onClick={() => !isDisable && handleOpen()}
        >
          {formatMessage({
            id: 'conversation.message.delete',
          })}{' '}
          ({selectedCount.toLocaleString()})
        </Typography>
      )}
      {isNil(selectedCount) && (
        <MenuItem onClick={() => handleOpen()} className="space-x-5">
          <DeleteOutlineIcon fontSize="small" className="text-red-500" />
          <Typography className="text-14 font-400 text-red-500">
            {formatMessage({
              id: 'action.delete',
            })}
          </Typography>
        </MenuItem>
      )}

      <SubmitDialog
        id="dialog-delete-subscriber"
        open={isOpen}
        type={CANCEL}
        title={title}
        description={description}
        submitText={formatMessage({
          id: 'action.delete',
        })}
        onSubmit={() => {
          onAction(SubscriberMenuAction.DELETE, selected)
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

Delete.propTypes = {
  onAction: PropTypes.func,
  selected: PropTypes.array,
  closeMenu: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  rootAdmin: PropTypes.object,
  selectedCount: PropTypes.number,
}

export default Delete
